import React from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import classNames from 'classnames'

/**
 * Tooltip component that displays a tooltip with customizable placement and behavior.
 * @param {{
 *  place?: 'top' | 'right' | 'bottom' | 'left',
 *  children: ReactNode,
 *  className?: string,
 * }} props
 */
export const Tooltip = ({ place = 'right', children, className, ...props }) => {
  return (
    <ReactTooltip
      place={place}
      className={classNames('tooltip', className)}
      globalCloseEvents={{ scroll: true }}
      disableStyleInjection
      {...props}
    >
      {children}
    </ReactTooltip>
  )
}
